module.exports = __webpack_public_path__ + "img/bush_blue.e6ea3044.svg";